const inputValidator = (name, value) => {
    let isValidated = true;
    if (name === 'email') {
        let match = value.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/);
        isValidated = (match || value === match || value === '') ? true : false;
    } else if (name === 'name' || name === 'firstName' || name.startsWith('ville')) {
        let match = value.match(/^[A-zÀ-ú- ]+$/);
        isValidated = (match || value === match || value === '') ? true : false;
    } else if (name.startsWith('rue')) {
        let match = value.match(/(\d{1,5}[ ,])?[\w\sÀ-ú-]{1,}/);
        isValidated = (match || value === match || value === '') ? true : false;
    } else if (name.startsWith('codePostal')) {
        let match = value.match(/^\d{5}$/);
        isValidated = (match || value === match || value === '') ? true : false;
    } else if (name === 'telephone') {
        let match = value.match(/^\d{10}$/);
        isValidated = (match || value === match || value === '') ? true : false;
    }
    return isValidated;
};

const getFormData = (form) => {
    let getValues = new FormData(form);
    let formData = {};
    for (let [key, value] of getValues) {
        formData[key] = value;
    }
    return formData;
};

export default{
    inputValidator,
    getFormData
};